import { Fragment } from "react"
import { JobProfileTableStyle } from "../job-profile-table/JobProfileTableStyle"

export default function JobProfileResponsibilitiesTable({ onDelete, data, actions }) {
	const items = [
		{
			name: "name",
			label: "Descripción",
			props: {},
		},
	]
	return (
		<Fragment>
			<JobProfileTableStyle
				{...{
					items,
					data,
					actions,
					onDelete,
				}}
			/>
		</Fragment>
	)
}
